// extracted by mini-css-extract-plugin
module.exports = {"layout":"_Index_layout_1B8fM","input-max-size":"_Index_input-max-size_1-06v"};